module.exports = {
    title: '测试环境',
    baseUrl: 'xxx', // 测试项目地址
    baseApi: 'https://test-gateway.hatelifu.club', // 测试api请求地址
    APPID: 'xxx',
    APPSECRET: 'xxx',
    $cdn: 'xxx'
}